import React, { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icon paths (Webpack quirk)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const homeIcon = L.divIcon({
  className: "",
  html: `<div style="background:#E32636;color:#fff;width:36px;height:36px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);display:grid;place-items:center;border:3px solid #fff;box-shadow:0 4px 14px rgba(0,0,0,0.3);"><span style="transform:rotate(45deg);font-size:18px;">🏠</span></div>`,
  iconSize: [36, 36],
  iconAnchor: [18, 36],
});

function Recenter({ position }) {
  const map = useMap();
  useEffect(() => {
    if (position) map.setView(position, 17, { animate: true });
  }, [position, map]);
  return null;
}

function ClickHandler({ onSelect }) {
  useMapEvents({
    click(e) {
      onSelect?.(+e.latlng.lat.toFixed(6), +e.latlng.lng.toFixed(6));
    },
  });
  return null;
}

/**
 * Client delivery position map — draggable marker to fine-tune the GPS point.
 * Props: lat, lng (numbers), onChange(lat, lng), height (default 200)
 */
export default function ClientPositionMap({ lat, lng, onChange, height = 200 }) {
  const position = useMemo(() => [lat, lng], [lat, lng]);

  return (
    <div
      style={{ height, width: "100%", borderRadius: "0.75rem", overflow: "hidden" }}
      className="border border-sand mt-3"
      data-testid="checkout-gps-map"
    >
      <MapContainer center={position} zoom={17} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Recenter position={position} />
        <ClickHandler onSelect={onChange} />
        <Marker
          position={position}
          icon={homeIcon}
          draggable
          eventHandlers={{
            dragend: (e) => {
              const p = e.target.getLatLng();
              onChange?.(+p.lat.toFixed(6), +p.lng.toFixed(6));
            },
          }}
        />
      </MapContainer>
    </div>
  );
}
